import { makeStyles, darken } from '@material-ui/core';
import { Theme } from 'enum';

export const useStyles = makeStyles((theme) => {
    const isDarkMode = theme.palette.type === Theme.Dark;
    const badgeStyles = {
        width: 14,
        height: 14,
        marginLeft: theme.spacing(1),
    };
    return {
        root: {
            minWidth: 400,
            backgroundColor: isDarkMode ? 'rgb(46, 47, 48)' : 'rgb(255,255,255)',
            '& .MuiButtonBase-root': {
                textTransform: 'none',
            },
            '& .MuiDivider-root': {
                backgroundColor: darken(isDarkMode ? 'rgb(46, 47, 48)' : 'rgb(255,255,255)', 0.1),
            },
            [theme.breakpoints.down('xs')]: {
                minWidth: '90vw',
            },
        },
        profileButton: {
            justifyContent: 'flex-start',
            textAlign: 'initial',
            padding: theme.spacing(3, 1, 1, 1),
        },
        avatar: {
            width: '35px',
            height: '35px',
            border: '0.5px solid rgba(255,255,255,0.05)',
        },
        userDetails: {
            display: 'flex',
            padding: theme.spacing(1),
            flexDirection: 'column',
        },
        userInfo: {
            display: 'flex',
            flexDirection: 'column',
            marginLeft: theme.spacing(2),
            justifyContent: 'center',
        },
        userName: {
            fontWeight: 600,
            fontSize: '1.1rem',
            lineHeight: 1.2,
        },
        userRole: {
            display: 'flex',
            alignItems: 'center',
            fontWeight: 600,
            fontSize: '1rem',
        },
        userMenu: {
            padding: theme.spacing(1),
        },
        userMenuItem: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: '100%',
            padding: theme.spacing(1),
            '& .MuiButton-startIcon': {
                marginLeft: 0,
            },
        },
        iconContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(0.75),
            borderRadius: '50%',
            fontSize: 20,
            backgroundColor: isDarkMode ? 'rgb(255,255,255,0.1)' : 'rgb(228, 230, 235)',
        },
        userMenuItemText: {
            marginLeft: theme.spacing(0.5),
            color: theme.palette.text.primary,
            fontWeight: 500,
        },
        prepaid: {
            ...badgeStyles,
            fill: '#27ae60',
        },
        standart: {
            ...badgeStyles,
            fill: '#2980b9',
        },
        premium: {
            ...badgeStyles,
            fill: '#f39c12',
        },
        professional: {
            ...badgeStyles,
            fill: '#f1c40f',
        },
        languageWrapper: {
            display: 'flex',
            minWidth: 160,
            marginLeft: theme.spacing(1),
            '& .MuiButton-root': {
                transition: 'none',
            },
        },
        language: {
            borderRadius: 50,
            color: theme.palette.text.secondary,
            textTransform: 'none',
            fontWeight: 600,
            textAlign: 'left',
            marginLeft: 0,
            marginTop: theme.spacing(1),
            backgroundColor: theme.palette.background.default,
        },
    };
});
